import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithPermissions } from 'react-admin';
import { push as pushAction } from 'react-router-redux';
import classNames from 'classnames';
import {
  ROLE_ADMIN, ROLE_CALLCENTER_ADMIN, ROLE_CALLCENTER_MANAGER, ROLE_COMPANY_ADMIN, ROLE_COMPANY_MANAGER
} from './config';
import './Menu.css';

const styles = {
  main: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '40px',
    color: '#fff'
  }
};

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admin: [
        {
          name: 'customer',
          text: 'Записи'
        },
        {
          name: 'payment',
          text: 'Финансы',
        },
        {
          name: 'statistics-company',
          text: 'Статистика',
          list: [
            {
              name: 'statistics-callcenter',
              text: 'По операторам'
            },
            {
              name: 'statistics-company',
              text: 'По компаниям'
            },
            {
              name: 'statistics-subject',
              text: 'По тематикам'
            },
            {
              name: 'requestlog',
              text: 'Лог'
            }
          ]
        },
        {
          name: 'clients',
          text: 'Клиенты',
        },
        {
          name: 'users',
          text: 'Пользователи',
        },
        {
          name: 'company',
          text: 'Компании',
        },
        {
          name: 'callcenter',
          text: 'Колцентры'
        }
        // {
        //   name: 'users',
        //   text: 'База',
        //   list: [
        //
        //   ]
        // }
      ],
      callcenterAdmin: [
        {
          name: 'customer',
          text: 'Записи'
        },
        {
          name: 'statistics-callcenter',
          text: 'По операторам'
        },
        {
          name: 'payment',
          text: 'Финансы'
        },
        {
          name: 'users',
          text: 'Пользователи',
        },
        {
          name: 'company',
          text: 'Компании',
        },
      ],
      callcenterManager: [
        {
          name: 'customer',
          text: 'Записи'
        },
        {
          name: 'statistics-callcenter',
          text: 'По операторам'
        }
      ],
      company: [
        {
          name: 'customer',
          text: 'Записи'
        },
        {
          name: 'clients',
          text: 'Клиенты'
        }
      ],
      isShowSubmenu: false
    };

    this.createMenuItem = this.createMenuItem.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClick() {
    if (this.state.isShowSubmenu) {
      this.handleClose();
    } else {
      this.setState({ isShowSubmenu: true });
    }
  }

  handleHover() {
    if (!this.state.isShowSubmenu) {
      this.setState({ isShowSubmenu: true });
    }
  }

  handleClose() {
    this.setState({ isShowSubmenu: false });
  }

  createMenuItem(menuItem, index, ar, isDropdown = false) {
    if (menuItem.hasOwnProperty('list')) {
      return (
        <div key={menuItem.name} className="topMenu_col" onMouseEnter={this.handleHover} onMouseLeave={this.handleClose}>
          <div
            className="topMenu_item" //"topMenu_item__ignoreclick"
            onMouseOver={this.handleHover}
            onClick={() => {
              if (menuItem.name !== this.props.currentpage) {
                this.props.onGoToPage(menuItem.name);
                this.handleClose();
              }
            }}
          >
            {menuItem.text}
          </div>
          <div style={{ display: this.state.isShowSubmenu ? 'block' : 'none' }}>
            {menuItem.list.map(menuItem => this.createMenuItem(menuItem, undefined, undefined, true))}
          </div>
        </div>
      );
    }

    const itemClassName = classNames({
      topMenu_item: true,
      topMenu_item__selected: this.props.currentpage === menuItem.name
    });

    return (
      <div
        key={menuItem.name}
        className={itemClassName}
        onClick={() => {
          if (menuItem.name !== this.props.currentpage) {
            this.props.onGoToPage(menuItem.name);
            this.handleClose();
          }
        }}
        onMouseOver={!isDropdown ? this.handleClose : null}
      >
        {menuItem.text}
      </div>);
  }

  render() {
    return (
      <div style={styles.main}>
        <WithPermissions>
          {({ permissions }) => {
            switch (permissions) {
              case ROLE_ADMIN:
                return <div className="topMenu_wrapper topMenu_row">{this.state.admin.map(this.createMenuItem)}</div>;
              case ROLE_CALLCENTER_ADMIN:
                return <div className="topMenu_wrapper topMenu_row">{this.state.callcenterAdmin.map(this.createMenuItem)}</div>;
              case ROLE_CALLCENTER_MANAGER:
                return <div className="topMenu_wrapper topMenu_row">{this.state.callcenterManager.map(this.createMenuItem)}</div>;
              case ROLE_COMPANY_ADMIN:
              case ROLE_COMPANY_MANAGER:
                return <div className="topMenu_wrapper topMenu_row">{this.state.company.map(this.createMenuItem)}</div>;
              default:
                return null;
            }
          }
        }
        </WithPermissions>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onGoToPage: (page) => {
    dispatch(pushAction(page));
  }
});
const mapStateToProps = (state) => ({ currentpage: state.sc.currentpage });

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);



// WEBPACK FOOTER //
// ./src/Menu.js